var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaWorkshopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 132,
    viewBox: "0 0 149 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.617 1.17792C146.735 0.352597 145.556 -0.0711207 144.345 0.00978162C89.3336 3.66581 59.3072 3.66581 4.65654 0.00978162C3.44941 -0.0699567 2.26585 0.351725 1.38349 1.17705C0.500838 2.00266 0 3.15712 0 4.36541V96.3263C0 97.5341 0.500547 98.688 1.38203 99.5133C2.26265 100.339 3.45523 100.763 4.65305 100.682C59.469 97.0583 89.4966 97.0583 144.347 100.682C145.555 100.763 146.736 100.339 147.618 99.5133C148.499 98.688 149 97.5341 149 96.3263V4.36541C149 3.15741 148.499 2.00353 147.617 1.17792Z",
    fill: "url(#paint0_linear_203_591)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0001 54.6747C84.023 54.6747 91.3375 47.3606 91.3375 38.3377C91.3375 29.3144 84.023 22 75.0001 22C65.9775 22 58.6628 29.3144 58.6628 38.3377C58.6628 47.3603 65.9772 54.6747 75.0001 54.6747ZM101.14 87.0001V85.264C101.14 71.0043 89.4364 59.4521 75 59.4521C60.5624 59.4521 48.8604 71.0074 48.8604 85.264V87.0001C48.8604 88.657 50.2035 90.0001 51.8604 90.0001H98.1399C99.7967 90.0001 101.14 88.657 101.14 87.0001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.953 122.845L89.6328 114.452V106.849C84.462 106.744 79.4501 106.694 74.4871 106.694C69.532 106.694 64.5283 106.744 59.3671 106.848V114.452L28.0472 122.845C25.7184 123.469 24.3364 125.862 24.9604 128.191C25.483 130.141 27.2466 131.428 29.174 131.428C29.5479 131.428 29.9283 131.379 30.3066 131.278L63.157 122.476C63.3459 122.501 85.6546 122.501 85.8434 122.476L118.694 131.278C119.072 131.379 119.452 131.428 119.826 131.428C121.754 131.428 123.518 130.141 124.04 128.191C124.663 125.862 123.281 123.469 120.953 122.845Z",
    fill: "url(#paint1_linear_203_591)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_591",
    x1: -156.062,
    y1: 210.506,
    x2: 137.221,
    y2: -20.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_591",
    x1: 4.50001,
    y1: 137.5,
    x2: 47.5036,
    y2: 52.2726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaWorkshopIcon);
export default __webpack_public_path__ + "static/media/media-workshop-icon.3cd99db7e3b3161314a9302a94694dfb.svg";
export { ForwardRef as ReactComponent };